exports.process = {
  nextTick: (cb, ...args) => setTimeout(cb, 0, ...args),
  env: {NODE_DEBUG: false},
  type: 'renderer',
};
